import authApi from './authApi';

let redirecting = false;

const PUBLIC_PATHS = new Set(['/', '/login', '/register']);

function isPublicPath(pathname) {
  if (PUBLIC_PATHS.has(pathname)) return true;
  return pathname.startsWith('/auth/');
}

function isAuthLoginRequest(url) {
  if (!url) return false;
  return String(url).includes('/api/auth/login');
}

export function isSessionExpiredPayload(status, data) {
  if (status !== 401) return false;
  if (!data || typeof data !== 'object') return true;
  if (data.code === 'AUTH_REQUIRED') return true;
  if (data.code === 'INVALID_CREDENTIALS' || data.code === 'INVALID_CURRENT_PASSWORD') return false;
  return true;
}

/**
 * Clear local auth state and send the user to login (full navigation so context resets).
 */
export function redirectToLoginAfterSessionExpired() {
  if (redirecting) return;

  const { pathname, search } = window.location;
  if (pathname === '/login') return;

  const hadToken = Boolean(authApi.getToken());
  if (!hadToken && isPublicPath(pathname)) return;

  redirecting = true;
  authApi.setToken(null);

  const returnTo = encodeURIComponent(pathname + search);
  window.location.assign(`/login?sessionExpired=1&redirect=${returnTo}`);
}

export function setupAxiosSessionInterceptor(axios) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      const url = error.config?.url;
      if (!isAuthLoginRequest(url) && isSessionExpiredPayload(status, data)) {
        redirectToLoginAfterSessionExpired();
      }
      return Promise.reject(error);
    }
  );
}

export function setupFetchSessionInterceptor() {
  if (typeof window === 'undefined' || window.__securepointFetchPatched) return;
  window.__securepointFetchPatched = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);
    const url = typeof input === 'string' ? input : input?.url;

    if (!isAuthLoginRequest(url) && response.status === 401) {
      let data = null;
      try {
        data = await response.clone().json();
      } catch (_) {
        data = null;
      }
      if (isSessionExpiredPayload(response.status, data)) {
        redirectToLoginAfterSessionExpired();
      }
    }

    return response;
  };
}

export function setupSessionExpiredHandling(axios) {
  setupAxiosSessionInterceptor(axios);
  setupFetchSessionInterceptor();
}
